import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=1025f460&scoped=true&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&id=1025f460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025f460",
  null
  
)

export default component.exports